import { Pipe, PipeTransform } from "@angular/core";
import * as marked from "marked";
import * as DOMPurify from 'dompurify';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {

    constructor(protected domSanitizer: DomSanitizer) {}

    transform(value: any): any {
        if (value && value.length > 0) {
            const sanitized =  DOMPurify.sanitize(marked(value));
            return this.domSanitizer.bypassSecurityTrustHtml(sanitized);
        }
        return value;
    }
}
